/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { withRouter } from 'react-router-dom';
import { ALL_ROUTES, MORE_MENU_SCREEN } from '../../global/Constants';
import { MORE_MENU_TYPES } from '../../global/Enum';
import '../../components/MoreMenu/more-menu.css';

class DesktopFooter extends Component {

    _handleClick(type) {
        switch (type) {
            case MORE_MENU_TYPES.ABOUT_THE_APP:
                this.props.history.push({
                    pathname: ALL_ROUTES.ABOUT_THE_APP_ROUTE,
                    state: { selectedTab: MORE_MENU_TYPES.ABOUT_THE_APP }
                })
                break;
            case MORE_MENU_TYPES.PRIVACY_POLICY:
                this.props.history.push({
                    pathname: ALL_ROUTES.PRIVACY_POLICY_ROUTE,
                    state: { selectedTab: MORE_MENU_TYPES.PRIVACY_POLICY }
                })
                break;
            case MORE_MENU_TYPES.NOTIFICATION:
                this.props.history.push({
                    pathname: ALL_ROUTES.NOTIFICATIONS_ROUTE,
                    state: { selectedTab: MORE_MENU_TYPES.NOTIFICATION }
                })
                break;
            case MORE_MENU_TYPES.SEND_FEEDBACK:
                this.props.history.push({
                    pathname: ALL_ROUTES.SEND_FEEDBACK_ROUTE,
                    state: { selectedTab: MORE_MENU_TYPES.SEND_FEEDBACK }
                })
                break;

            default:
                break;
        }

    }

    render() {
        return (
            <footer>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-5">
                            <p>{MORE_MENU_SCREEN.COPYRIGHT_TITLE}</p>
                        </div>
                        <div className="col-lg-7">
                            <ul>
                                <li onClick={() => {this._handleClick(MORE_MENU_TYPES.ABOUT_THE_APP)}}>{MORE_MENU_SCREEN.ABOUT_US}</li>
                                <li onClick={() => {this._handleClick(MORE_MENU_TYPES.PRIVACY_POLICY)}}>{MORE_MENU_SCREEN.PRIVACY_POLICY}</li>
                                <li onClick={() => {this._handleClick(MORE_MENU_TYPES.NOTIFICATION)}}>{MORE_MENU_SCREEN.NOTIFICATIONS}</li>
                                <li onClick={() => {this._handleClick(MORE_MENU_TYPES.SEND_FEEDBACK)}}>{MORE_MENU_SCREEN.SEND_FEEDBACK}</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </footer>
        );
    }
}

export default withRouter(DesktopFooter)


